import $ from 'jquery';

//Workaround for not registering first click on Safari touch
$($('.is-dropdown-submenu > .menu-item').find('a')).on('touchstart', e =>{
  location.href = $(e.target).attr('href');
});